import {useDispatch, useSelector} from "react-redux";
import {dialogs, hideDeleteOrgDialog, extendedOrganization, loading} from "../../../store/slice";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Button} from "@mui/material";
import {LocalSpinner} from "../../../../../../shared/components/Spinner";
import {DeleteOrganization} from "../../../store/actions";

export const DeleteOrganizationDialog = () => {
    const dispatch = useDispatch();
    const {deleteOrganizationDialog: {isOpen}} = useSelector(dialogs);
    const org = useSelector(extendedOrganization);
    const {isLoadingDeleteOrg} = useSelector(loading);

    const handleClose = () => {
        dispatch(hideDeleteOrgDialog());
    };

    const handleDeleteOrg = () => {
        if(org){
            dispatch(DeleteOrganization({id: org.id}));
        }
    }

    return(
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>Delete organization</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want delete this organization and all related data?
                </DialogContentText>
            </DialogContent>
            {isLoadingDeleteOrg ?
                <LocalSpinner />
                :
                <DialogActions>
                    <Button onClick={handleClose} color={'warning'}>Cancel</Button>
                    <Button onClick={handleDeleteOrg} disabled={!org} color={'success'}>Delete</Button>
                </DialogActions>
            }
        </Dialog>
    )
}